import { VStack } from '@chakra-ui/react';
import { colors, spacing } from '../../../../../../App/ChakraTheme';
import styled from '../../../../../../consts/styled';

export const StyledTable = styled(VStack)`
  margin-bottom: ${spacing.BASE};
  padding-bottom: 16px !important;
  margin-top: 0px !important;
  width: 100%;

  .checkCircle {
    margin: 0 auto;
    margin-right: ${spacing.TINY};
  }

  .studentName {
    padding-left: ${spacing.TINY};
    padding-right: ${spacing.TINY};
    padding-top: 2px;
    padding-bottom: 2px;
    color: ${colors.applyOpacity(colors.midnight, 0.9)};
    font-family: 'Open Sans';
    text-align: left;
    flex: 0 1 auto;
    min-width: 140px;
    max-width: min(42%, 340px);
    white-space: normal;
    word-break: break-word;
    overflow: visible;
    line-height: 1.35;
  }

  body.chakra-ui-dark & .studentName {
    color: #e2e8f0;
  }

  .studentName a {
    text-decoration: none;
  }

  .studentName a:hover {
    text-decoration: underline;
  }

  .analyticsRow .row-cs {
    align-items: center;
  }

  .analyticsRow {
    align-items: center;
    padding-left: 4px;
  }

  /* Shared analytics student grid (lessons, quizzes, uploads, exercises) */
  .analyticsStudentGridRow .studentName {
    flex: unset;
    min-width: 0;
    max-width: 100%;
  }

  .analyticsStudentGridRow .checkCircle {
    margin: 0;
    margin-right: 0;
  }

  .analyticsRow:nth-child(2n-1) {
    background-color: #dddddd;
  }

  body.chakra-ui-dark & .analyticsRow:nth-child(2n-1) {
    background-color: #1e293b;
  }
`;
